import React from "react"

import {useStore} from "zustand"
import type {LangLoaderStore} from "./langStore"

export type LangLoaderContext = LangLoaderStore

const langLoaderContext = React.createContext<null | LangLoaderContext>(null)

export const LangLoaderProvider = React.memo(langLoaderContext.Provider)

function useLangStoreCtx() {
  const ctx = React.useContext(langLoaderContext)
  if (!ctx) {
    throw new Error("useLangStore must be used inside the LangProvider")
  }
  return ctx
}

export function useLangLoaderActions() {
  const store = useLangStoreCtx()
  return useStore(store, (s) => s.actions)
}

export function useLangStoreMessages() {
  return useStore(useLangStoreCtx(), (state) => state.messages)
}

export function useLangStoreLang() {
  const store = useLangStoreCtx()
  return useStore(store, (state) => state.locale)
}

export function useLangLoader(buckets: string[]) {
  const store = useLangStoreCtx()
  return useStore(store, (state) => buckets.every((b) => state.buckets[b]?.ready))
}
